var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconXmlFileFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_18248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.66 3.90002H14.54V5.46002H17.66V3.90002Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.66 6.40002H14.54V7.96002H17.66V6.40002Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.66 8.90002H14.54V10.46H17.66V8.90002Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.66 11.39H14.54V12.95H17.66V11.39Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.66 13.89H14.54V15.45H17.66V13.89Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1.84H11.78V0H10.68L0 1.86V17.63L10.86 19.64H11.8V17.51H20V1.84ZM8.27 13.38H6.66L5.47 10.63L4.55 13.18L2.92 13.11L4.71 9.74L3.13 6.23H4.66L5.61 8.57L6.67 5.95H8.26L6.5 9.74L8.26 13.38H8.27ZM19.37 16.87H11.8V15.45H13.62V13.89H11.79V12.95H13.62V11.39H11.79V10.45H13.62V8.89H11.79V7.95H13.62V6.39H11.78V5.45H13.62V3.89H11.78V2.47H19.36V16.86L19.37 16.87Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_18248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.63,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXmlFileFill);
export default __webpack_public_path__ + "static/media/icon_xml_file_fill.c87c2361720f4fc007bb3d50053ed265.svg";
export { ForwardRef as ReactComponent };